import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { KlmrFuelAddPage } from '../klmr-fuel-add/klmr-fuel-add';

@IonicPage()
@Component({
  selector: 'page-klmr-fuel',
  templateUrl: 'klmr-fuel.html',
})
export class KlmrFuelPage {
  fuelList: any = [];
  appColor:String;
  actionAllowed:boolean = false;
  filledByList: any = [];
  monthSelected:any = null;
  monthList:any = [
    {"value":"all","name":"All"},
    {"value":"january","name":"January"},
    {"value":"feburary","name":"Feburary"},
    {"value":"march","name":"March"},
    {"value":"april","name":"April"},
    {"value":"may","name":"May"},
    {"value":"june","name":"June"},
    {"value":"july","name":"July"},
    {"value":"august","name":"August"},
    {"value":"september","name":"September"},
    {"value":"october","name":"October"},
    {"value":"november","name":"November"},
    {"value":"december","name":"December"},
  ];


  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getMetaData();
    this.getPermission();
    this.getappColor();
    this.getfuelList();

  }

  async searchByMonth(){
   
      this.getfuelListByFilter();
  }

  async getMetaData(){
    this.filledByList = await this.getFilledBtList();
  }

  async getappColor(){
    this.appColor = await this.utiltiy.getStorage("primaryColor");
  }

   getUserName(id){
    let name = null;
    let index = this.filledByList.findIndex(list_ => list_.ID == id);
    if(index != -1){
      name = this.filledByList[index].firstName +" "+this.filledByList[index].surname;
    }else{
      name = id;
    }
    return name;
  }

  

  getfuelListByFilter() {
    
    this.fuelList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    if(this.monthSelected != "all"){
      formData.append("month_name", this.monthSelected);
    }

    let baseUrl = this.monthSelected != "all"?"/prestart/fuel/fuel/Fuel_get/search_by_month":"/prestart/fuel/fuel/Fuel_get/show_all_records"

    this.api.post(baseUrl, false,formData)
      .then((result: any) => {
        console.log("result", result)
        this.fuelList = result.result;
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  getfuelList() {
    this.fuelList = [];
    this.utiltiy.startLoading();
    this.api.get("/prestart/fuel/fuel/get", false)
      .then((result: any) => {
        console.log("result", result)
        this.calculatefuelList(result.result);
        // this.fuelList = result.result;
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }


  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deletePrestart(id);
    }
    console.log("status", status);
  }

  async getFilledBtList() {
    this.filledByList = [];
    // this.utiltiy.startLoading();
    return this.api.get("/prestart/fuel/users/get", false)
      .then((result: any) => {
        console.log("result", result)
        result.result.forEach(element => {
          element.name = element.firstName + " " + element.surname;
        });
        // this.utiltiy.stopLoading();
        if (result.status) {
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }

  async calculatefuelList(fuelList){
   console.log("fuelList",fuelList)
    let array = [];
    let totalLtrs = 0;
    let keys = Object.keys(fuelList);
    keys = keys.reverse();
    keys.forEach(element => {
      totalLtrs = 0;
      console.log("---",element)
      let monthKeys = Object.keys(fuelList[element].months)
      monthKeys = monthKeys.reverse();
      let childArray = [];
      let obj = {} as any;
      obj.name = element;
      monthKeys.forEach(element_ => {
        const monthNames = ["","January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
        ];
        if(fuelList[element].months[element_].records.length > 0){

          // let int = parseFloat(fuelList[element].months[element_].LTRS);
          // fuelList[element].months[element_].LTRS = int
          totalLtrs = fuelList[element].LTRS;
          // console.log("fuelList[element].months[element_]",fuelList[element].months[element_])
          console.log("totalLtrs",totalLtrs)
          childArray.push({"records":fuelList[element].months[element_], "monthName": monthNames[element_]})
        }
      });
      obj.totalLtr = totalLtrs;
      obj.children = childArray;
      array.push(obj)
    });
    console.log("array----",array)
    this.fuelList = array;
  }

  
  maintenancetoggleSection(i){
    this.fuelList[i].open = !this.fuelList[i].open;
  }

  maintenancetoggleItem(i,j){
    this.fuelList[i].children[j].open = ! this.fuelList[i].children[j].open;
  }



  deletePrestart(id) {
    this.api.delete(`/prestart/fuel/fuel/delete/${id}`, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.getfuelList();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }
  
  addfuel(){
   this.navCtrl.push(KlmrFuelAddPage, { param: null });
 }
 updatePrestart(prestart){
   this.navCtrl.push(KlmrFuelAddPage, { param: prestart });
 }
 async getPermission(){
  this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-fuel-rw");
 }
}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel/klmr-fuel.ts